export const THEME_LIST = 'THEME_LIST'
export const CHANGE_THEME = 'CHANGE_THEME'

export default  {
    THEME_LIST,
    CHANGE_THEME
}